export default {
  ENTER: 13,

  // used for accessibility
  TAB: 9,
  SPACE:32,
  ARROW_UP: 38,
  ARROW_DOWN: 40
};
